import React, { useState } from "react";
import CoachesImage from "../../assets/images/coaches.jpg";
import styles from "./Coaches.module.scss";
import {Steps} from "antd";
import CoachStepOne from "../../components/coaches-program/CoachStepOne";
import CoachStepTwo from "../../components/coaches-program/CoachStepTwo";
import CoachStepThree from "../../components/coaches-program/CoachStepThree";
import CoachStepFour from "../../components/coaches-program/CoachStepFour";

const { Step } = Steps;

const Coaches = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [courseId, setCourseId] = useState("");

  return (
      <div className={styles.CoachesContainer}>
        <img className={styles.CoachesPhoto} src={CoachesImage} alt="Coaches" />
        <div className={styles.CoachStepper}>

          <Steps
              current={currentStep}
              progressDot
              direction="horizontal"
              responsive={false}
          >
            <Step />
            <Step />
            <Step />
            <Step />
          </Steps>

          {currentStep === 0 && <CoachStepOne setCurrentStep={setCurrentStep} setCourseId={setCourseId} />}
          {currentStep === 1 && <CoachStepTwo setCurrentStep={setCurrentStep} />}
          {currentStep === 2 && <CoachStepThree setCurrentStep={setCurrentStep}/>}
          {currentStep === 3 && <CoachStepFour courseId={courseId}/>}
        </div>
      </div>
  );
};

export default Coaches;
